module.exports = __webpack_public_path__ + "static/media/al_flow_login.27243452.svg";